export enum CommonFilterSwitch {
    ALL,
    FALSE,
    TRUE,
}
export type PlanRefType = {
    name: number;
    status: number;
    operationType: number;
    airport: number;
    location: number;
    main: number;
};
